import { TravelJournalCategoryType } from 'types/types';
import styles from './CategoriesGrid.module.scss';
import { travelJournalHeroWEBP } from 'assets';
import Image from 'next/image';
import CategoryLink from '../category-link';
import Container from 'components/container';

interface CategoriesGridProps {
  categories: TravelJournalCategoryType[];
}

const CategoriesGrid: React.FC<CategoriesGridProps> = ({ categories }) => {
  return (
    <Container as="nav" className={styles.container}>
      {categories.map(category => (
        <div key={category.id} className={styles.item}>
          <CategoryLink category={category}>
            <Image
              src={category.image!}
              objectPosition="center"
              objectFit="cover"
              alt={category.name}
              layout="fill"
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 640px, 828px"
            />
            <div className={styles.itemLabel}>{category.name}</div>
          </CategoryLink>
        </div>
      ))}
    </Container>
  );
};

export default CategoriesGrid;
